<template>
	<div v-if="order_detail" class="ord">
		<naviBack type='list1' title="订单详情" background="#ffffff" />

		<!-- <div>
			<div>
				<van-notice-bar color="rgba(215,0,16,0.7)" background="rgba(215,0,16,0.03)" :left-icon="note_icon">
					订单申请取消中
				</van-notice-bar>
			</div>
		</div> -->
		<!-- bookStatus -1/0 待确认 1已确认 2 已完成 3已取消 -->
		<div class="ord_1">
			<div class="ord_1_1 font_weight">
				<img v-if="order_detail.bookStatus==-1 || order_detail.bookStatus==0 || order_detail.bookStatus==1"
					src="../resource/order_1.png" alt="" />
				<img v-if="order_detail.bookStatus==2" src="../resource/order_1.png" alt="" />
				<img v-if="order_detail.bookStatus==3" src="../resource/order_1.png" alt="" />
				{{order_detail.bookStatus==-1?'待确认':''}}
				{{order_detail.bookStatus==0?'待确认':''}}
				{{order_detail.bookStatus==1?'待使用':''}}
				{{order_detail.bookStatus==2?'已完成':''}}
				{{order_detail.bookStatus==3?'已取消':''}}
			</div>
			<div v-if="order_detail.bookStatus==-1 || order_detail.bookStatus==0" class="ord_1_2">服务正在确认中...</div>
			<div v-if="order_detail.bookStatus==1" class="ord_1_2">
				请在
				<div>
					{{order_detail.bookDate}}
					{{order_detail.bookTime?' '+order_detail.bookTime:''}}
				</div>
				到店使用
			</div>
			<!-- <div v-if="order_detail.cancelRule && order_detail.bookStatus==0" class="ord_1_3">
				*{{order_detail.cancelRule}}
			</div>
			<div v-if="order_detail.cancelRule && order_detail.bookStatus==1" class="ord_1_3">
				*{{order_detail.cancelRule}}
			</div> -->
			<div @click="flashOrder()" class="ord_1_4">
				<img src="../resource/flash.png" alt="" />
			</div>
		</div>
		<div class="ord_body">
			<div>
				<div class="ord_2">
					<div class="ord_2_title font_weight">{{order_detail.serviceName}}预约</div>
					<div class="ord_2_address white_space">预约日期　{{order_detail.bookDate}} {{order_detail.bookTime}}
					</div>
					<div class="ord_2_address white_space">预约人　　{{order_detail.bookName}} {{order_detail.bookMobile}}
					</div>
				</div>
			</div>
			<!-- <div v-if="order_detail.type=='site_price'">
				<div class="ord_2">
					<div class="ord_2_title font_weight">{{order_detail.goods_name}}预约</div>
					<div class="ord_2_address white_space">预约日期　{{order_detail.book_day}} {{order_detail.book_time}}
					</div>
					<div class="ord_2_address white_space">预约人　　{{order_detail.book_name}} {{order_detail.book_mobile}}
					</div>
				</div>
			</div>
			<div v-if="order_detail.type=='voucher'">
				<div class="ord_2">
					<div class="ord_2_title font_weight">{{order_detail.goods_name}}预约</div>
					<div class="ord_2_address white_space">有效期　　{{order_detail.begin_date}}至{{order_detail.end_date}}
					</div>
					<div class="ord_2_address white_space">预约人　　{{order_detail.book_name}} {{order_detail.book_mobile}}
					</div>
				</div>
			</div> -->

			<!-- <div v-if="order_detail.type=='site_price' && order_detail.site_infos && order_detail.site_infos.length>0"
				class="dsco_body_2 dsco_body_2_mabot width_100 border_radius_16 bg_FFFFFF">
				<div class="dsco_body_2_1 width_100 color_333333 font_weight_600 font_size_30 display_start_center">
					{{order_detail.goods_name}}
					<div class="font_size_20 color_F77F28">{{order_detail.book_day_obj.date_ymdmd}}
						{{order_detail.book_day_obj.week}}
					</div>
				</div>
				<div class="dsco_body_2_2_out width_100 text_ellipsis2">
					<div v-for="(cl_item,cl_index) in order_detail.site_infos" :key="'cl_index'+cl_index"
						class="dsco_body_2_2_block">
						<div class="dsco_body_2_2 border_radius_8 display_center_center text_align_center">
							<div>
								<div class="font_size_20 color_666666">{{cl_item.siteName}}</div>
								<div class="font_size_22 color_333333 dsco_body_2_2_time">
									{{cl_item.beginTime}}-{{cl_item.endTime}}
								</div>
								<div class="font_size_22 color_F77F28">¥ {{cl_item.price}}</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->
			<div v-if="order_verfiy_detail && order_verfiy_detail.codeM">
				<div @click="getDtVerifyCode2()" class="ord_2 ord_2copy">
					<div class="width_100 font_size_32 color_333333 font_weight_600">下场方式</div>
					<div class="width_100 display_center_center">
						<canvas ref="qrcodeCanvas"
							id="qrcodeCanvas"></canvas>
					</div>
					<div class="width_100 display_center_center">
						<div class="ord_2_vc display_center_end font_size_50 color_F77F28 font_weight_600">
							{{order_verfiy_detail.codeM}}
							<img src="../resource/flash.png" alt="" />
						</div>
					</div>
					<div
						class="width_100 font_size_24 color_666666 text_align_center display_center_center"
						style="margin-bottom: 10px;">
						有效期至<div class="color_F77F28">{{order_verfiy_detail.endTime}}</div>，点击可刷新
					</div>
					<div class="width_100 font_size_24 color_666666 text_align_center">到场使用该券码进行核销使用</div>
				</div>
			</div>

			<div v-if="order_detail.cancelRule" class="ord_2">
				<div class="width_100 font_size_32 color_333333 font_weight_600">退订规则</div>
				<div class="ord_2_address width_100" v-text="order_detail.cancelRule" style="white-space: pre-line;">
				</div>
			</div>

			<div v-if="order_detail.venueAddress" class="ord_2">
				<div class="width_100 font_size_32 color_333333 font_weight_600">{{order_detail.venueName}}</div>
				<div class="ord_2_address width_100 display_start_start text_ellipsis2">地址：<div
						style="white-space: normal;">{{order_detail.venueAddress}}</div>
				</div>
			</div>

			<div class="ord_4">
				<div class="ord_4_title font_weight">订单信息</div>
				<div class="ord_4_item">
					订单编号
					<div>{{order_detail.orderNo}}</div>
				</div>
				<div class="ord_4_item">
					下单时间
					<div>{{order_detail.createTime}}</div>
				</div>
				<div class="ord_4_item">
					订单总额(积点)
					<div>{{order_detail.orderAmount}}</div>
				</div>
				<div class="ord_4_item">
					积点抵扣
					<div>-{{order_detail.orderAmount}}</div>
				</div>
			</div>

			<div v-if="order_detail.canCancel && order_detail.canCancel==1" class="ord_5">
				<!-- <div>取消订单</div> -->
			</div>
			
			<div v-if="order_detail.canCancel && order_detail.canCancel==1" class="ord_7  width_100 bg_FFFFFF display_between_center">
				<div @click="getStockInfo()" class="ord_71 color_666666 display_center_center font_size_32">修改订单</div>
				
				<div @click="cancelOrderBefore()" class="ord_72 color_ffffff display_center_center font_size_32">取消订单</div>
			</div>
			
		</div>

		<timePop :goods_detail="order_detail" ref='time_pop' @flashOrder="flashOrder" />
	</div>
</template>

<script>
	import QRCode from 'qrcode'
	import naviBack from '../components/navi_back.vue';
	import timePop from '../components/time_change_pop.vue';
	import {
		datePrintStr,
		expEasyNumber
	} from "../lib/utils.js"
	import {
		login,
		getOrderDetail,
		cancelOrder,
		getDtVerifyCode
	} from '../api/api.js'

	export default {
		components: {
			naviBack,timePop
		},
		data() {
			return {
				is_load: false,
				order_detail: null, //订单详情

				order_verfiy_detail: null,

				note_icon: 'https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20250926_A6aHgXlDZUlN5AX.png'
			}
		},
		mounted() {
			// console.log(this.$route);
			// alert(JSON.stringify(this.$route.query))
			this.$RCLoading.show();
			this.initUser()
			// this.getOrderDetail()
			// this.$loading('正在加载中...');
			// document.title = '订单列表'
			// console.log(this.$route.params.order_no);
			// 
		},
		methods: {
			async initUser() {
				var $this = this
				// console.log(this.$route.query);
				// this.getOrderDetail()
				// return
				try {
					var res = await login(this.$route.query)
					// console.log(res);
					if (res.data && res.data.token && res.data.token.token) {
						sessionStorage.setItem('token', res.data.token.token)
						setTimeout(() => {
							$this.getOrderDetail()
						}, 50)
					} else {
						$this.$RCLoading.hide();
						$this.$toast('用户信息解析失败，请联系管理人员')
					}
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			// 订单详情
			async getOrderDetail() {
				var $this = this
				// $this.$RCLoading.hide();
				// var params=
				// console.log(this.$route);
				// params.orderNo='8F3A26011454544953270736'
				try {
					var res = await getOrderDetail(this.$route.query)
					console.log(res);
					// res.data.bookDate_obj=datePrintStr(res.data.bookDate)
					if (res.data.verifyCode) {
						res.data.verifyCodeM = expEasyNumber(res.data.verifyCode)
					}
					$this.order_detail = res.data

					if (res.data.bookStatus == 1) {
						$this.getDtVerifyCode()
					} else {
						$this.order_verfiy_detail = null
						$this.$RCLoading.hide();
					}
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			async getDtVerifyCode() {
				var $this = this
				var params = {
					orderNo: $this.order_detail.orderNo
				}
				try {
					var res = await getDtVerifyCode(params)
					console.log(res);
					if (res.data.code) {
						res.data.codeM = expEasyNumber(res.data.code)
					}
					$this.order_verfiy_detail = res.data
					$this.$nextTick(() => {
					    if(res.data.code){
							$this.getQrCode()
						}
					});
					$this.$RCLoading.hide();
					// setTimeout(()=>{
					// 	$this.$RCLoading.show();
					// 	$this.getOrderDetail()
					// },60000)
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			async getQrCode() {
				try {
					var qrContent = this.order_verfiy_detail.code
					var qrOptions = {
						width: 150, // 二维码宽度（像素）
						margin: 2, // 二维码四周留白
						color: {
							dark: '#000000', // 二维码深色模块颜色
							light: '#ffffff' // 二维码浅色背景颜色
						}
					}

					// 获取Canvas DOM 元素
					const canvas = this.$refs.qrcodeCanvas
					// 核心方法：toCanvas - 将内容生成二维码并渲染到Canvas
					await QRCode.toCanvas(canvas, qrContent, qrOptions)
					console.log('二维码生成成功（Canvas）')
				} catch (error) {
					console.error('二维码生成失败：', error)
				}
			},
			getDtVerifyCode2() {
				this.$RCLoading.show();
				this.getDtVerifyCode()
			},
			// 打开地图
			openMap() {
				window.location.href =
					`https://uri.amap.com/marker?position=${this.order_detail.lon},${this.order_detail.lat}&name=${this.good_info.address}`;
			},
			// 取消订单
			cancelOrderBefore() {
				var $this = this
				this.$dialog.confirm({
						title: '温馨提示',
						message: '是否申请取消订单?',
						confirmButtonColor: '#F77F28',
						confirmButtonText: '取消订单',
						cancelButtonColor: '#999999',
						cancelButtonText: '暂不取消'
					})
					.then(() => {
						// on confirm
						this.$RCLoading.show();
						$this.cancelOrder()
					})
					.catch(() => {
						// on cancel
					});
			},
			async cancelOrder() {
				var $this = this
				var params = {
					orderNo: $this.order_detail.orderNo
				}
				try {
					var res = await cancelOrder(params)
					$this.getOrderDetail()
				} catch (error) {
					$this.$RCLoading.hide();
					//TODO handle the exception
				}
			},
			flashOrder() {
				this.$RCLoading.show();
				this.getOrderDetail()
			},
			getStockInfo() {
				this.$refs.time_pop.getStockInfo()
			},
		},
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	// @import "../css/custom_elementui.less";
	// @import "../modules3/css/custom_elementui.less";

	.ord_2_address {
		margin-top: 10*@vm_base;
		line-height: 1.3;

		div {
			line-height: 1.3;
		}
	}

	.ord {
		width: 100%;
		min-height: 100vh;
		background: #F6F7F9;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
	}

	.ord_1 {
		width: 100%;
		padding: 30*@vm_base 140*@vm_base 30*@vm_base 40*@vm_base;
		background: #ffffff;
		position: relative;

		.ord_1_1 {
			font-size: 36*@vm_base;
			color: #333333;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			img {
				width: 40*@vm_base;
				margin-right: 10*@vm_base;
			}
		}

		.ord_1_2 {
			width: 100%;
			font-size: 28*@vm_base;
			color: #666666;
			margin-top: 20*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			div {
				color: #F77F28;
			}
		}

		.ord_1_3 {
			width: 100%;
			font-size: 24*@vm_base;
			color: #999999;
			margin-top: 14*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.ord_1_4 {
			position: absolute;
			top: 0;
			right: 0;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 0 40*@vm_base;

			img {
				width: 40*@vm_base;
			}
		}
	}

	.ord_body {
		width: 100%;
		padding: 30*@vm_base 20*@vm_base 0 20*@vm_base;
	}

	.ord_2 {
		width: 100%;
		padding: 30*@vm_base 20*@vm_base;
		border-radius: 16*@vm_base;
		background-color: #ffffff;
		margin-bottom: 20*@vm_base;

		.ord_2_title {
			font-size: 32*@vm_base;
			color: #333333;
		}

		.ord_2_address {
			width: fit-content;
			max-width: 100%;
			font-size: 28*@vm_base;
			padding: 2*@vm_base 0;
			color: #666666;
			margin-top: 16*@vm_base;
			line-height: 1.3;
		}

		.ord_2_msg {
			width: 100%;
			margin-top: 35*@vm_base;
			border-top: 1*@vm_base dashed #D9D9D9;
			padding-top: 35*@vm_base;
			font-size: 30*@vm_base;
			color: #333333;
		}

		.ord_2_code {
			width: 100%;
			padding: 40*@vm_base 0 10*@vm_base 0;
			font-size: 50*@vm_base;
			text-align: center;
			color: #F77F28;
		}
	}

	.ord_3 {
		width: 100%;
		padding: 30*@vm_base 20*@vm_base;
		border-radius: 16*@vm_base;
		background-color: #ffffff;
		margin-bottom: 20*@vm_base;

		.ord_3_title {
			font-size: 30*@vm_base;
			color: #333333;
		}

		.ord_3_address {
			width: fit-content;
			max-width: 100%;
			font-size: 28*@vm_base;
			padding: 2*@vm_base 0;
			color: #666666;
			margin-top: 20*@vm_base;
			background-size: auto 100%;
			background-position: right center;
			background-repeat: no-repeat;
		}
	}

	.ord_4 {
		width: 100%;
		padding: 30*@vm_base 20*@vm_base;
		border-radius: 16*@vm_base;
		background-color: #ffffff;
		margin-bottom: 20*@vm_base;

		.ord_4_title {
			font-size: 30*@vm_base;
			color: #333333;
		}

		.ord_4_item {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 28*@vm_base;
			color: #666666;
			margin-top: 30*@vm_base;

			div {
				color: #333333;
			}
		}
	}

	.ord_5 {
		width: 100%;
		height: 120*@vm_base
		
		
		// padding: 80*@vm_base 0 100*@vm_base 0;

		// div {
		// 	width: 180*@vm_base;
		// 	height: 60*@vm_base;
		// 	border-radius: 16*@vm_base;
		// 	border: 1*@vm_base solid #D9D9D9;
		// 	display: flex;
		// 	justify-content: center;
		// 	align-items: center;
		// 	font-size: 28*@vm_base;
		// 	color: #999999;
		// 	margin: 0 auto;
		// }
	}

	.ord_6 {
		width: 100%;
		padding: 30*@vm_base 20*@vm_base;
		border-radius: 16*@vm_base;
		background-color: #ffffff;
		margin-bottom: 20*@vm_base;
		position: relative;

		.ord_6_1 {
			width: 100%;
			font-size: 26*@vm_base;
			color: #333333;
			line-height: 1.3;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.ord_6_2 {
			width: 100%;
			font-size: 24*@vm_base;
			color: #999999;
			line-height: calc(34 / 24);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			padding-left: 42*@vm_base;
			margin-top: 10*@vm_base;
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240723_ePa0I5qL1eTe16G.png);
			background-repeat: no-repeat;
			background-position: left center;
			background-size: auto 80%;
		}

		.ord_6_3 {
			width: 100%;
			font-size: 24*@vm_base;
			color: #999999;
			line-height: calc(34 / 24);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			margin-top: 10*@vm_base;
		}
	}

	.dsco_body_2 {
		padding: 30*@vm_base 20*@vm_base;

		.dsco_body_2_1 {
			div {
				margin-left: 20*@vm_base;
			}
		}

		.dsco_body_2_2_out {
			overflow: hidden;
			overflow-x: auto;
			margin-top: 30*@vm_base;
		}

		.dsco_body_2_2_block {
			display: inline-block;
			margin-right: 30*@vm_base;

			&:last-child {
				margin-right: 0;
			}
		}

		.dsco_body_2_2 {

			width: 180*@vm_base;
			height: 124*@vm_base;
			background: #F6F7F9;

			.dsco_body_2_2_time {
				padding: 10*@vm_base 0;
			}
		}
	}

	.dsco_body_2_mabot {
		margin-bottom: 20*@vm_base;
	}

	.ord_2_vc {
		padding: 40*@vm_base 0 24*@vm_base;
		position: relative;

		img {
			width: 30*@vm_base;
			margin-left: 10*@vm_base;
			margin-bottom: 5*@vm_base;
		}
	}
	
	.ord_7{
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 1;
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		padding: 25*@vm_base 30*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 25*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 25*@vm_base);
		box-shadow: -4*@vm_base -4*@vm_base 6*@vm_base rgba(243, 207, 166, 0.5);
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		div {
			width: calc(50% - 15*@vm_base);
			height: 80*@vm_base;
			border-radius: 40*@vm_base;
		}
		.ord_71{
			border: 1*@vm_base solid #D9D9D9;
		}
		.ord_72{
			background: linear-gradient(233deg, #FB8027 0%, #FFA663 100%);
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/order_detail.vue